import MuiDatePicker, { DatePickerProps as MuiDatePickerProps } from '@mui/lab/DatePicker';

import { ReactComponent as CalendarIcon } from 'src/assets/images/calendarIcon.svg';

const DatePicker: React.FC<MuiDatePickerProps> = props => {
  return <MuiDatePicker {...props} components={{ OpenPickerIcon: CalendarIcon }} />;
};

export default DatePicker;
